/**
 * Whether the visitor has accepted statistics cookies in the EasyCookie banner. False until the EasyCookie script
 * has run and the visitor has saved the banner with statistics on, and false outside the browser.
 */
export const hasStatisticsConsent = () => typeof window !== 'undefined' && window.EasyCookie?.getConsent()?.s === true;
